// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

window.createMigrationApp = (tag) => {
  const vueApp = new Vue({
    el: tag,
    router,
    template: '<App/>',
    components: {
      App
    },
    provide () {
      return {
        'pg1': 'Plugin Name 1',
        'pg2': 'Plugin Name 2'
      }
    }
  })

  return vueApp
}



// WEBPACK FOOTER //
// ./src/main.js